


































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';

export default {
    name: 'TheWorkingHoursFields',
    components: {
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            time: Object(),
        };
    },
    methods: {
        onSubmit() {
            this.$emit('addWorkingHour', {
                day: this.time.day,
                start: this.time.start,
                end: this.time.end,
            });
        },
    },
    created() {
        this.day = {
            day: '',
            start: '',
            end: '',
        };
    },
};
